import api from '../../../utils/api'
import { useState, useEffect, useMemo } from "react"
import { FiInbox } from 'react-icons/fi'

/* form */
import Input from "../../../shared/components/form/input"
import Button from "../../../shared/components/Button/Button"

/* Hooks */
import useMyPermission from '../../../hooks/useMyPermission'

import ListCostRow from './ListRow/ListCostRow'
import Modal from '../../../shared/modal/Modal'
import NewCost from './NewCost'

function Cost({ providerId, selectItem, handleOnSelectItem, selectedData, btCancelAction }) {

    const [token] = useState(localStorage.getItem('token') || '')
    const [costs, setCosts] = useState([])
    const [modalNew, setModalNew] = useState(false)

    const [search, setSearch] = useState("")
    const [load, setLoad] = useState(false)

    /* ---------------------- Permission ------------------------- */
    const [myPermission, setMyPermission] = useState({ group: "", })
    const { checkPermission } = useMyPermission()
    const myPermissionNew = checkPermission(myPermission, "cost_create")
    const myPermissionView = checkPermission(myPermission, "cost_view")
    const myPermissionEdit = checkPermission(myPermission, "cost_edit")
    const myPermissionDelete = checkPermission(myPermission, "cost_delete")

    /* get all function */
    const getAll = () => {
        api.get(`/cost/getall`, {
            params: providerId ? { provider: providerId } : {},
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },
        }).then((response) => {
            if (response) {
                setCosts(response.data.costs)
                setMyPermission(response.data.permission)
                setLoad(true)
            }
        })
    }

    /* use effect */
    useEffect(() => {
        getAll()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token, providerId])

    /* ----------------------- Search function ---------------------------------- */
    const filter = useMemo(() => {
        const searchLowerCase = search.toLowerCase()
        return costs.filter((item) =>
            item.cost.toString().includes(search) ||
            (item.description && item.description.toLowerCase().includes(searchLowerCase))
        )
    }, [costs, search])

    function handleSearch(e) {
        setSearch(e.target.value)
    }

    if (!load) {
        return <div className="pg-loading">Carregando custos...</div>
    }

    /* PAGE */
    return myPermissionView ? (
        <section className="pg-page">

            <div className="pg-sticky-top">
                <div className="pg-header">
                    <div className="pg-header-title">
                        <p className="pg-title">Custo por Unidade</p>
                        <span className="pg-title-accent" />
                    </div>
                    <div className="pg-header-row">
                        <div className="pg-header-actions">
                            {myPermissionNew && (
                                <Button variant="new" onClick={() => setModalNew(true)}>Cadastrar</Button>
                            )}
                            {btCancelAction && (
                                <Button variant="finish" onClick={btCancelAction}>Concluir</Button>
                            )}
                        </div>
                        <div className="pg-header-right">
                            <div className="pg-search">
                                <Input
                                    type="text"
                                    name="search"
                                    placeholder="Buscar por valor ou descrição..."
                                    value={search}
                                    handleOnChange={handleSearch}
                                />
                            </div>
                            <span className="pg-count">
                                {filter.length} {filter.length === 1 ? 'custo' : 'custos'}
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <div className="pg-list">
                {filter.length > 0 ? (
                    <ListCostRow
                        dataArray={filter}
                        providerId={providerId}
                        handleOnSuccess={getAll}
                        handleOnSelectItem={handleOnSelectItem}
                        myPermissionEdit={myPermissionEdit}
                        myPermissionDelete={myPermissionDelete}
                        myPermissionView={myPermissionView}
                        selectItem={selectItem}
                        selectedData={selectedData}
                    />
                ) : (
                    <div className="pg-empty">
                        <FiInbox size={32} className="pg-empty-icon" />
                        <p className="pg-empty-title">Nenhum custo por unidade encontrado</p>
                        <p className="pg-empty-subtitle">
                            {costs.length === 0
                                ? 'Cadastre o primeiro custo por unidade para começar.'
                                : 'Tente ajustar a busca.'}
                        </p>
                    </div>
                )}
            </div>

            <Modal
                modalStatus={modalNew}
                changeStatus={setModalNew}
                w={92}
                t={3}
                h={90}
                content={
                    <NewCost providerId={providerId} btCancelAction={() => setModalNew(false)} handleOnSuccess={() => { setModalNew(false); getAll() }} />
                }
            />

        </section>
    ) : (
        <div className="pg-empty">
            <p className="pg-empty-title">Sem permissão para visualizar custos por unidade</p>
        </div>
    )
}

export default Cost
